import { all, fork } from '@redux-saga/core/effects';
//import {
//  waitForPolygonData,
//  waitForTrafficData,
//} from '../../components/AzureMap/organisms/AzureMapContainer/AzureMap.sagas';
import { waitForAvailableFeedData } from '../../components/public/SubscriberDataFeed/organisms/AvailableDataFeedContainer/AvailableDataFeed.sagas';
import {
  waitForSubscribedFeedData,
  waitForUpdatedFeedData,
} from '../../components/public/SubscriberDataFeed/molecules/SubscribedFeedsContainer/SubscribedFeedsContainer.sagas';
//import {
//  waitForAvailableAlertEvents,
//  waitForCurrentAlertEvent,
//} from '../../components/operator/AlertsList/organisms/AlertsList.sagas';
import { waitForDataFeedStatus } from '../../components/public/SubscriberDataFeed/organisms/ConfigureDataFeedContainer/ConfigureDataFeed.sagas';
/**
 * Method for registering the sagas.
 */
export default function* sagas() {
  yield all([
    //fork(waitForPolygonData),
    //fork(waitForTrafficData),
    fork(waitForAvailableFeedData),
    fork(waitForSubscribedFeedData),
    fork(waitForUpdatedFeedData),
    //fork(waitForAvailableAlertEvents),
    fork(waitForDataFeedStatus),
    //fork(waitForCurrentAlertEvent),
  ]);
}
